import { render, staticRenderFns } from "./IndexContent2.vue?vue&type=template&id=5864da52&scoped=true"
import script from "./IndexContent2.vue?vue&type=script&lang=js"
export * from "./IndexContent2.vue?vue&type=script&lang=js"
import style0 from "./IndexContent2.vue?vue&type=style&index=0&id=5864da52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864da52",
  null
  
)

export default component.exports